import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const InstallPWAPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setDeferred(null);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    if (sessionStorage.getItem("ysv_pwa_dismissed")) setDismissed(true);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || dismissed || !deferred) return null;

  const install = async () => {
    try {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      if (outcome !== "accepted") {
        setDismissed(true);
        sessionStorage.setItem("ysv_pwa_dismissed", "1");
      }
      setDeferred(null);
    } catch (err) {
      setDismissed(true);
    }
  };

  const close = () => {
    setDismissed(true);
    sessionStorage.setItem("ysv_pwa_dismissed", "1");
  };

  return (
    <div
      data-testid="pwa-install-banner"
      style={{
        position: "fixed", bottom: 76, left: 16, right: 16, zIndex: 80,
        maxWidth: 420, margin: "0 auto", background: "#1a2230",
        border: "1px solid #253040", borderRadius: 14, padding: "14px 16px",
        boxShadow: "0 12px 40px rgba(0,0,0,0.5)",
        display: "flex", alignItems: "center", gap: 12,
      }}
    >
      <div style={{
        width: 40, height: 40, borderRadius: 10, background: "var(--cyan)",
        display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
      }}>
        <Download size={20} style={{ color: "#000" }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>Install YSV</p>
        <p style={{ fontSize: 12, color: "#888" }}>Get the full app experience on your home screen.</p>
      </div>
      <button data-testid="pwa-install-btn" onClick={install} style={{
        padding: "8px 14px", background: "var(--cyan)", color: "#000",
        border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer",
      }}>Install</button>
      <button data-testid="pwa-install-close" onClick={close} aria-label="Dismiss" style={{
        background: "transparent", border: "none", cursor: "pointer", color: "#888", padding: 4,
      }}>
        <X size={16} />
      </button>
    </div>
  );
};

export default InstallPWAPrompt;
